// initial state
const state = {
  map: {},
};

// getters
const getters = {
  get: (state) => {
    return state.map;
  },
};

// actions
const actions = {
  set({ commit }, { path, data }) {
    if (path && data) {
      commit('set', { path, data });
    }
  },
  delete({ commit }, { path, key }) {
    if (path) {
      commit('delete', { path, key });
    }
  },
};

// mutations
const mutations = {
  set(state, { path, data }) {
    state.map[path] = data;
  },
  delete(state, { path, key }) {
    if (key) {
      delete state.map[path]?.[key];
    } else {
      delete state.map[path];
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
